/* tslint:disable */
/* eslint-disable */
export enum WorkAccountingPartnerTypeEnum {
  Supplier = 'supplier',
  Customer = 'customer',
  Employee = 'employee'
}
